"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressNftListResponseValueToJSON = exports.AddressNftListResponseValueFromJSONTyped = exports.AddressNftListResponseValueFromJSON = void 0;
function AddressNftListResponseValueFromJSON(json) {
    return AddressNftListResponseValueFromJSONTyped(json, false);
}
exports.AddressNftListResponseValueFromJSON = AddressNftListResponseValueFromJSON;
function AddressNftListResponseValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hex': json['hex'],
        'repr': json['repr'],
    };
}
exports.AddressNftListResponseValueFromJSONTyped = AddressNftListResponseValueFromJSONTyped;
function AddressNftListResponseValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hex': value.hex,
        'repr': value.repr,
    };
}
exports.AddressNftListResponseValueToJSON = AddressNftListResponseValueToJSON;
//# sourceMappingURL=AddressNftListResponseValue.js.map